/** ***
------------------------------------------------------------------------
LOGIN FAILURES BY AGENT ID LIST PAGE
------------------------------------------------------------------------
  Host Name
  Targeted User
  Count

** ***/
const loginFailuresLinuxTopAgentListMetaInfo = {
  meta: {
    columns: [
      {
        datatype: 'string',
        display: 'threathunting',
        description: 'IP',
        label: 'IP',
        'min-width': 250,
        sortable: true,
        name: 'entity',
        search: [
          {
            name: 'edgeName',
            operator: 'in',
            values: ['1109', '1100']
          },
          {
            name: 'destAddr',
            operator: 'eq',
            values: [],
            queryField: 'destAddr',
            lookupField: 'entity'
          },
          {
            name: 'externalDestAddr',
            operator: 'eq',
            values: ['true']
          }
        ]
      },
      {
        datatype: 'string',
        description: 'Top Host',
        label: 'Top Host',
        'min-width': 150,
        sortable: true,
        name: 'hostname'
      },
      {
        datatype: 'number',
        description: 'Count',
        label: 'Count',
        sortable: true,
        'min-width': 150,
        name: 'count'
      }
    ]
  }
}

export { loginFailuresLinuxTopAgentListMetaInfo }



// WEBPACK FOOTER //
// ./src/column-header/statistics/loginfailureslinux-topagents-meta.js